import React, { useState, useEffect } from 'react';
import { history } from 'ice';
import { Drawer, Input, Form, Radio, Select, Message, Modal } from '@b-design/fusion';
import $i18n from '../../i18n';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import Uploader from '../Uploader';
import DefaultLogo from '@/assets/app-logo.png';
import { Field } from '@alifd/next';
import store from '@/store';
import debounce from 'lodash/debounce';
import Button, { FormSubmit, promisifyValidate } from '@/components/Button';

import './index.less';

interface Props {
  visible: boolean;
  setVisible: any;
  status?: string;
  setCreateTitle?: any;
  appInfo?: any;
  setTabListTitle?: any;
  channel?: any;
  setInfoContent?: any;
  appTypeInfo?: any;
}

const { Option } = Select;

const Index: React.FC<Props> = ({
  visible,
  setVisible,
  status,
  setCreateTitle,
  appInfo,
  setTabListTitle,
  channel,
  setInfoContent,
  appTypeInfo,
}) => {
  const [appType, setAppType] = useState('WindVane');
  // const [belong, setBelong] = useState();
  const { appId, spaceId } = getQueryStringArgs();
  const field = Field.useField();
  const { init, getValue, setValue, getError } = field;
  const [icon, setIcon] = useState<any>({ publicUrl: '', relativePath: '' });
  const [channels, setChannels] = useState([]);
  const [siteSettingsState] = store.useModel('siteSettings');
  const [spaceRoleState] = store.useModel('spaceRole');

  const initFormData = () => {
    Requests.get('/rest/intercnn/publishChannel/pageQuery', {
      currentPage: 1,
      pageSize: 10000,
      draftStatus: 'ONLINE',
      spaceId,
      belongSpaceId: spaceRoleState?.belongSpaceId || '',
    }).then((data) => {
      const { list: allChannels = [] } = data;
      const channelCodeList = allChannels.map((i) => i.innerCode);
      Requests.get('/rest/intercnn/app/publish/query', {
        appId,
        channelCodeList: channelCodeList.join(','),
      }).then((res) => {
        const { list: toChannel } = res;
        let resList = allChannels;
        const arr = toChannel.filter((item) => item.description.inherit === false);
        for (let i = 0; i < arr.length; i++) {
          resList = resList.filter((item) => item.innerCode !== arr[i].channelCode);
        }
        setChannels(resList);
        // setValue('party', toChannel[0]?.description?.party);
      });
    });
  };

  useEffect(() => {
    if (visible) {
      if (status === 'edit' || status === 'addInfo' || status === 'editInfo') {
        setAppType(appTypeInfo);
        // setBelong(appInfo.party);
        setValue('appName', appInfo.name);
        setValue('party', appInfo.party);
        setValue('slogan', appInfo.slogan);
        setValue('description', appInfo.description);
        setValue('email', appInfo.customerEmail);
        setValue('phonePrev', appInfo.customerPhone.split('-')[0]);
        setValue('phone', appInfo.customerPhone.split('-')[1]);
        // setValue('logo', [{ publicUrl: appInfo.icon, relativePath: appInfo.iconRelative }]);
        setIcon({ publicUrl: appInfo.icon, relativePath: appInfo.iconRelative });
      }

      if (status === 'addInfo') {
        setValue('targetApp', '');
        initFormData();
      }

      if (status === 'editInfo') {
        setValue('targetApp', appInfo.channelName);
      }
    }
  }, [visible]);

  const submitFormInfo = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }
    let iconParam = {};
    if (icon?.relativePath && icon?.relativePath !== '') {
      iconParam = {
        icon: icon?.relativePath,
        iconPublicUrl: icon?.publicUrl,
      };
    }

    const params = {
      channelCode: getValue('targetApp'),
      ...(spaceRoleState.roleList?.includes('ADMIN') &&
        spaceRoleState.type === 'CONSUMER' && { party: getValue('party') }),
      appDescription: {
        customerEmail: getValue('email'),
        customerPhone: getValue('phonePrev') + '-' + getValue('phone'),
        description: getValue('description'),
        slogan: getValue('slogan'),
        name: getValue('appName'),
        inherit: false,
        ...iconParam,
      },
    };

    const data = await Requests.post('/rest/intercnn/app/publish/update', { ...params, appId });
    if (data) {
      Message.success({
        title: $i18n.get({
          id: 'aopf.pages.miniapp.drawer.form.Created.successfully',
          dm: '创建成功',
        }),
      });
      setVisible(false);
      setTabListTitle('addInfo');
      setIcon({ publicUrl: '', relativePath: '' });
    }
  };

  // 提交表单
  const submitForm = async () => {
    const [errs, vals] = await promisifyValidate(field);
    if (errs) {
      return;
    }
    let iconParam = { icon: null, iconPublicUrl: null };
    if (icon?.relativePath && icon?.relativePath !== '') {
      iconParam = {
        icon: icon?.relativePath,
        iconPublicUrl: icon?.publicUrl,
      };
    }
    const params: any = {
      // devPlatform: '',
      framework: appType, // 小程序容器类型
      platform: 'MiniApp', // platform这一期就只有MiniApp，以后可能会拓展
      spaceId: spaceId,
      ...(spaceRoleState.roleList?.includes('ADMIN') &&
        spaceRoleState.type === 'CONSUMER' && { party: getValue('party') }),
      description: {
        customerEmail: getValue('email'),
        name: getValue('appName'),
        slogan: getValue('slogan'),
        description: getValue('description'),
        customerPhone: getValue('phonePrev') + '-' + getValue('phone'),

        ...iconParam,
      },
    };

    
      if (status !== 'edit' && status !== 'editInfo') {
        try {
          const data = await Requests.post('/rest/intercnn/app/create', { ...params, spaceId }, {}, true);
          if (data) {
            Message.success({
              title: $i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Created.successfully',
                dm: '创建成功',
              }),
            });
            setVisible(false);
            setIcon({ publicUrl: '', relativePath: '' });
            setCreateTitle && setCreateTitle('createMiniapp');
            if (window.location?.pathname === '/guidance') {
              history?.push(`/overview?spaceId=${spaceId || ''}`);
            }
          }
        } catch (error) {
          if (error?.errorCode === 'INTCNN_APP_NUM_LIMIT') {
            Modal.error({
              title: $i18n.get({ id: 'aopf.component.header.FailedToCreate', dm: '创建失败' }),
              content: $i18n.get({
                id: 'aopf.component.header.TheMaximumCreationValueHas',
                dm: '已达到最大创建值',
              }),
              footer: null,
            });
          } else {
            Message.error(
              error?.Detail ||
                error?.errorMsg ||
                $i18n.get({
                  id: 'aopf.src.services.request.InterfaceRequestError',
                  dm: '接口请求错误',
                }),
            );
          }
        }
      } else if (status === 'edit') {
        params.appId = appId;
        const data = await Requests.post('/rest/intercnn/app/update', { ...params, spaceId });
        if (data) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Update.successfully',
              dm: '更新成功',
            }),
          });
          setVisible(false);
          setCreateTitle('updateMiniapp');
          setIcon({ publicUrl: '', relativePath: '' });
        }
      } else if (status === 'editInfo') {
        const infoParams = {
          channelCode: channel,
          ...(spaceRoleState.roleList?.includes('ADMIN') &&
            spaceRoleState.type === 'CONSUMER' && { party: getValue('party') }),
          appDescription: {
            customerEmail: getValue('email'),
            name: getValue('appName'),
            slogan: getValue('slogan'),
            description: getValue('description'),
            customerPhone: getValue('phonePrev') + '-' + getValue('phone'),
            inherit: false,
            ...iconParam,
          },
        };
        const data = await Requests.post('/rest/intercnn/app/publish/update', { ...infoParams, appId });
        if (data) {
          Message.success({
            title: $i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Update.successfully',
              dm: '更新成功',
            }),
          });
          setVisible(false);
          setInfoContent('updateMiniappInfo');
        }
      }
  };

  const changeAppType = (value) => {
    setAppType(value);
    if (value === 'UniApp') {
      setValue('party', 'THIRD');
    }
  };

  // const changeBelong = (v) => {
  //   setBelong(v);
  // };

  const renderTitle = () => {
    if (status === 'addInfo') {
      return $i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Add.Information', dm: '添加信息' });
    } else if (status === 'edit' || status === 'editInfo') {
      return $i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Edit.Miniapp', dm: '修改应用' });
    } else {
      return $i18n.get({ id: 'aopf.pages.miniapp.drawer.miniapp.create', dm: '创建应用' });
    }
  };

  return (
    <Drawer
      className="miniapp-create-drawer"
      title={renderTitle()}
      placement="right"
      data-size="large"
      onClose={() => {
        setVisible(false);
        setIcon({ publicUrl: '', relativePath: '' });
      }}
      visible={visible}
      headerStyle={{
        fontWeight: 500,
        fontSize: 16,
        color: '#121c2d',
        letterSpacing: '0.15px',
        lineHeight: '24px',
      }}
    >
      <div className="create-drawer-container">
        <div className="create-drawer-content">
          <Form>
            {status === 'addInfo' ? (
              // || title === 'editInfo'
              <Form.Item
                name="targetApp"
                label={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Target.APP',
                  dm: '当前应用',
                })}
                required
              >
                <Select
                  placeholder={$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.Industry.placeholder',
                    dm: '请选择',
                  })}
                  style={{ width: '500px' }}
                  {...init('targetApp', {
                    initValue: '',
                    rules: {
                      required: true,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.Miniapp.target.app.placeholder',
                        dm: '请选择targetApp',
                      }),
                    },
                  })}
                  popupProps={{ v2: true }}
                  popupClassName="b-design-select"
                  hasClear
                  // disabled={title === 'editInfo'}
                >
                  {channels.map((item: any) => (
                    <Option value={item.innerCode} key={item.innerCode}>
                      <img src={item.iconPublicUrl} style={{ width: 20, height: 20 }} alt="" />{' '}
                      {item.name}
                    </Option>
                  ))}
                </Select>
                <p className="form-create-err-msg-p">{getError('targetApp')}</p>
              </Form.Item>
            ) : null}
            <Form.Item
              name="appName"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name',
                dm: '应用名称',
              })}
              required
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
                  dm: '请输入唯一的名称，长度为2~36个字符',
                })}
                style={{ width: '500px' }}
                {...init('appName', {
                  initValue: '',
                  rules: {
                    required: true,
                    minLength: 2,
                    maxLength: 36,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
                      dm: '请输入唯一的名称，长度为2~36个字符',
                    }),
                  },
                })}
              />

              <p className="form-create-err-msg-p">{getError('appName')}</p>
            </Form.Item>
            <Form.Item
              name="appType"
              label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Type', dm: '类型' })}
              required
            >
              <Radio.Group
                shape="button"
                data-shape="container"
                defaultValue={
                  status === 'edit' || status === 'editInfo' || status === 'addInfo'
                    ? appTypeInfo
                    : 'WindVane'
                }
                onChange={changeAppType}
                disabled={status === 'edit' || status === 'editInfo' || status === 'addInfo'}
              >
                <Radio id="Windvane" value="WindVane" data-ctype="icon-text">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.Type.Windvane',
                    dm: 'Windvane',
                  })}
                </Radio>
                <Radio id="Uniapp" value="UniApp" data-ctype="icon-text">
                  {$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Type.Uniapp', dm: 'Uniapp' })}
                </Radio>
              </Radio.Group>
              {appType === 'UniApp' ? (
                <div className="form-radio-uniapp-tip">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.Type.Uniapp.tip',
                    dm: '不要使用下载的IDE，直接使用HBuilder',
                  })}
                </div>
              ) : null}
            </Form.Item>
            {spaceRoleState.roleList?.includes('ADMIN') && spaceRoleState.type === 'CONSUMER' && (
              <Form.Item
                name="party"
                label={$i18n.get({
                  id: 'aopf.pages.miniapp.create.drawer.belongTo',
                  dm: '小程序权限',
                })}
                required
              >
                <Radio.Group
                  shape="button"
                  data-shape="container"
                  // onChange={changeBelong}
                  disabled={status === 'edit' || status === 'editInfo' || status === 'addInfo'}
                  {...init('party', {
                    initValue: '',
                    rules: {
                      required: true,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.create.drawer.belongTo.check',
                        dm: '请选择小程序权限',
                      }),
                    },
                  })}
                >
                  <Radio id="THIRD" value="THIRD" data-ctype="icon-text">
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.create.drawer.tripartiteMiniApp',
                      dm: '普通',
                    })}
                  </Radio>
                  <Radio
                    id="PRIVILEGE"
                    value="PRIVILEGE"
                    data-ctype="icon-text"
                    disabled={appType === 'UniApp'}
                  >
                    {$i18n.get({
                      id: 'aopf.pages.miniapp.create.drawer.oneSideMiniapp',
                      dm: '特权',
                    })}
                  </Radio>
                </Radio.Group>
                <p className="form-create-err-msg-p">{getError('party')}</p>
                <div className="form-radio-uniapp-tip">
                  {$i18n.get({
                    id: 'aopf.pages.miniAppStore.create.drawer.party.desc',
                    dm: '特权小程序：允许调用APP SDK的高级接口以获取额外数据。仅对当前空间的APP生效。',
                  })}
                </div>
              </Form.Item>
            )}

            <Form.Item
              name="slogan"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Slogan',
                dm: '口号',
              })}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Miniapp.slogan.placeholder',
                  dm: '请输入口号，长度为2~36个字符',
                })}
                maxLength={36}
                style={{ width: '500px' }}
                {...init('slogan', {
                  initValue: '',
                  rules: {
                    minLength: 2,
                    maxLength: 36,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.Miniapp.slogan.placeholder',
                      dm: '请输入口号，长度为2~36个字符',
                    }),
                  },
                })}
              />

              <p className="form-create-err-msg-p">{getError('slogan')}</p>
            </Form.Item>
            <Form.Item
              name="description"
              label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Description', dm: '描述' })}
            >
              <Input.TextArea
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Description.placeholder',
                  dm: '输入2-400个字符的描述',
                })}
                autoHeight={{ minRows: 4, maxRows: 8 }}
                style={{ width: '500px' }}
                {...init('description', {
                  initValue: '',
                  rules: {
                    minLength: 2,
                    maxLength: 400,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.Description.placeholder',
                      dm: '输入2-400个字符的描述',
                    }),
                  },
                })}
                showLimitHint
                maxLength={400}
              />

              <p className="form-create-err-msg-p">{getError('description')}</p>
            </Form.Item>
            <Form.Item
              name="logo"
              label={$i18n.get({ id: 'aopf.pages.miniapp.drawer.form.Logo', dm: '图标' })}
              className="logo"
            >
              <Uploader.Image
                {...init('logo', {})}
                action="/rest/intercnn/app/uploadIcon"
                accept={['image/png', 'image/jpg', 'image/jpeg']}
                data={
                  status === 'create' ? { spaceId: spaceId } : { spaceId: spaceId, appId: appId }
                }
                key={icon?.relativePath}
                value={
                  icon?.relativePath
                    ? [
                        {
                          uid: '0',
                          state: 'done',
                          url: icon?.publicUrl,
                          downloadURL: icon?.publicUrl,
                          imgURL: icon?.publicUrl,
                          relativePath: icon?.relativePath,
                          publicUrl: icon?.publicUrl,
                        },
                      ]
                    : []
                }
                maxSize={1024 * 1024}
                onCheckFail={(_err, response) => {
                  Message.warning({ title: response.msg });
                }}
                onError={() => {
                  Message.error({
                    title: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.icon.Upload.failure',
                      dm: '上传失败',
                    }),
                  });
                }}
                changeValue={setIcon}
                defaultImg={
                  siteSettingsState?.miniappDefaultIcon
                    ? siteSettingsState?.miniappDefaultIcon
                    : DefaultLogo
                }
                version={true}
              />

              {/* <div className="default-icon-wrapper">
                 <span className="tips">
                   {$i18n.get({
                     id: 'aopf.pages.miniapp.drawer.form.icon.Upload.or.use',
                     dm: '或者',
                   })}
                 </span>
                 <DefaultAppIcon className="default-icon" />
                </div> */}
              <div className="upload-format">
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format1',
                  dm: '文件类型:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format1.content',
                    dm: '.png / .jpg / .jpeg',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format2',
                  dm: '规格:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format2.content',
                    dm: '180px * 180px',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format3',
                  dm: '最大大小:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format3.content',
                    dm: '1M',
                  })}
                </span>
                <br />
                {$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.upload.img.format4',
                  dm: '背景:',
                })}
                <span>
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.upload.img.format4.content',
                    dm: '不透明',
                  })}
                </span>
              </div>
              <p className="form-create-err-msg-p">{getError('logo')}</p>
            </Form.Item>
            <Form.Item
              name="phone"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Number',
                dm: '客服电话',
              })}
            >
              <Input
                placeholder="60"
                style={{ width: '100px' }}
                {...init('phonePrev', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[\d]{1,4}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                        dm: '请输入正确的手机号',
                      }),
                    },
                  ],
                })}
              />

              <span className="form-create-phone-span">-</span>
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Number.placeholder',
                  dm: '填写电话',
                })}
                style={{ width: 385 }}
                {...init('phone', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[\d]{1,11}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                        dm: '请输入正确的手机号',
                      }),
                    },
                  ],
                })}
              />

              {getError('phone') || getError('phonePrev') ? (
                <p className="form-create-err-msg-p">
                  {$i18n.get({
                    id: 'aopf.pages.miniapp.drawer.form.phone.err.msg',
                    dm: '请输入正确的手机号',
                  })}
                </p>
              ) : null}
            </Form.Item>
            <Form.Item
              name="email"
              label={$i18n.get({
                id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email',
                dm: '客服邮箱',
              })}
            >
              <Input
                placeholder={$i18n.get({
                  id: 'aopf.pages.miniapp.drawer.form.Customer.Service.Contact.Email.placeholder',
                  dm: 'example@email.com',
                })}
                style={{ width: '500px' }}
                {...init('email', {
                  initValue: '',
                  rules: [
                    {
                      pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,}$/,
                      message: $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.form.email.msg',
                        dm: '请输入正确的邮箱',
                      }),
                    },
                  ],
                })}
              />

              <p className="form-create-err-msg-p">{getError('email')}</p>
            </Form.Item>
            <Form.Item name="agree">
              {status !== 'addInfo' ? (
                <FormSubmit
                  type="primary"
                  onClick={submitForm}
                  validate
                  style={{
                    height: 40,
                    borderRadius: 4,
                    fontWeight: 500,
                    fontSize: 16,
                    color: '#fff',
                    letterSpacing: '0.15px',
                    marginTop: 30,
                  }}
                >
                  {status !== 'edit' && status !== 'editInfo'
                    ? $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.miniapp.create.btn',
                        dm: '创建',
                      })
                    : $i18n.get({
                        id: 'aopf.pages.miniapp.drawer.miniapp.update.btn',
                        dm: '更新',
                      })}
                </FormSubmit>
              ) : (
                <>
                  <FormSubmit
                    type="primary"
                    onClick={submitFormInfo}
                    validate
                    style={{
                      height: 40,
                      fontWeight: 500,
                      fontSize: 16,
                      color: '#fff',
                      letterSpacing: '0.15px',
                      marginTop: 30,
                    }}
                  >
                    {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.ok', dm: '确认' })}
                  </FormSubmit>
                  <Button
                    type="secondary"
                    style={{
                      height: 40,
                      borderRadius: 4,
                      fontWeight: 500,
                      fontSize: 16,
                      letterSpacing: '0.15px',
                      marginTop: 30,
                      marginLeft: 16,
                    }}
                    onClick={() => {
                      setVisible(false);
                      setIcon({ publicUrl: '', relativePath: '' });
                    }}
                  >
                    {$i18n.get({ id: 'aopf.pages.miniapp.detail.btn.cancel', dm: '取消' })}
                  </Button>
                </>
              )}
            </Form.Item>
          </Form>
        </div>
      </div>
    </Drawer>
  );
};

export default Index;
